import PropTypes from 'prop-types';
import React from 'react';

import { Button, DotsGrid, Trash01 } from '@opendate-app/setlist';

const PageDetailFrame = ({
  csrfToken,
  team,
  currentUser,
  confirm,
  pageDetail,
  children,
  provided,
  deletePageDetail
}) => (
  <div className="form-row pb-3">
    <div className="col">
      {children}
    </div>
    <div className="col-xs-auto"
         style={{"paddingRight": "15px"}}>
      <ul className={"no-bullets p-0 " + (pageDetail.type === "PageDetails::Video" ?  "mt-4" : "")}>
        <li className="mb-2">
          <Button variant="tertiary"
                  size="sm"
                  icon={Trash01}
                  aria-label="Remove"
                  onClick={() => deletePageDetail(csrfToken, team, pageDetail)} />
        </li>
        <li>
          <span {...provided.dragHandleProps}
                aria-label="Drag to reorder"
                className="d-flex justify-content-center"
                style={{"color": "var(--sl-text-quaternary)"}}>
            <DotsGrid width={16} height={16} />
          </span>
        </li>
      </ul>
    </div>
  </div>
);

PageDetailFrame.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  pageDetail: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
  provided: PropTypes.object.isRequired,
  deletePageDetail: PropTypes.func.isRequired
};

export default PageDetailFrame;
